<template>
	<label class="icon-container">
		<img
			class="icon-image"
			:src="require(`@/drc/assets/icons/${imageName}`)"
			alt="icon"
			@mouseover="hoverIn()"
			@mouseout="hoverOut()"
			:style="{ width: iconWidth, height: iconHeight }"
			@click="iconClick"
		>
		<transition name="fade">
			<span v-if="displayHint" class="icon-tooltip"> {{ hoverText }} </span>
		</transition>
	</label>
</template>

<script>
export default {
	name: "IconTooltip",
	props: {
		iconClick: {
			type: Function,
			required: true
		},
		imageName: {
			type: String,
			required: true
		},
		hoverText: {
			type: String,
			required: true
		},
		iconWidth: {
			type: String,
			required: false,
			default: "25px",
		},
		iconHeight: {
			type: String,
			required: false,
			default: "fit-content",
		},
	},
	data() {
		return {
			displayHint: false
		}
	},
	methods: {
		hoverIn() {
			this.displayHint = true;
		},
		hoverOut() {
			this.displayHint = false;
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.icon-container {
	position: relative;
	display: flex;
	align-self: center;

	.icon-image {
		padding: 5px;
		cursor: pointer;
		position: relative;
		min-width: 20px;

		@media (max-width: $tablet) {
			width: 3vw!important;
		}

		@media (max-width: 780px) {
			width: 4vw!important;
			min-width: 30px;
		}
	}

	.icon-tooltip {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translate(-50%, -100%);
		width: fit-content;
		background-color: $dark-grey;
		padding: 5px 10px;
		border-radius: 3px;

		@media (max-width: $mobile) {
			display: none;
		}
	}

	.fade-enter-active, .fade-leave-active {
		transition: opacity 0.3s ease-in-out;
	}

	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
}
</style>
